import React from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as SuccessToast } from '../assets/img/checkmark.svg';
import { StyledToastCloseIcon } from '../globalStyled';

export const ToastCloseButton = ({ closeToast }) => (
  <StyledToastCloseIcon
    role="button"
    aria-label="Dismiss notification"
    tabIndex={0}
    onClick={closeToast}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        closeToast(event);
      }
    }}
  />
);

export const toastRender = (toastType = 'error', toastMessage) => {
  if (toastType === 'success') {
    toast.success(toastMessage, {
      icon: <SuccessToast />,
      closeButton: ToastCloseButton,
    });
    return true;
  }
  if (toastType === 'error') {
    toast.error(toastMessage, { closeButton: ToastCloseButton });
    return true;
  }
  if (toastType === 'warning') {
    toast.warn(toastMessage, { closeButton: ToastCloseButton });
    return true;
  }
};
